import { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import { MapView } from "@/components/MapView";
import { FilterBar } from "@/components/FilterBar";
import { api } from "@/lib/api";

export default function MapPage() {
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/listings", { params: { ...filters, limit: 200 } });
      setItems(data);
    })();
  }, [filters]);

  return (
    <Layout withFooter={false}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8">
        <span className="text-xs tracking-[0.2em] uppercase text-[#11783A] font-medium">Carte interactive</span>
        <h1 className="font-heading text-4xl md:text-5xl font-medium tracking-tight mt-2 mb-6">
          Explorez le Maghreb sur la carte
        </h1>

        <div className="mb-6">
          <FilterBar onSearch={setFilters} compact />
        </div>

        <MapView listings={items} country={filters.country || "ALL"} height="75vh" />

        <p className="text-sm text-muted-foreground mt-4 text-center">
          {items.length} annonce{items.length > 1 ? "s" : ""} affichée{items.length > 1 ? "s" : ""} sur la carte
        </p>
      </div>
    </Layout>
  );
}
